import styles from './File.module.css';
import type { FC } from 'react';
import type { FileProps } from './File.types';
import { Icon, ButtonGroup, Flex, Pill, Text } from '@/_components';
import { getClasses } from '@/_utils/classnames';

export const File: FC<FileProps> = ({
  icon = 'file',
  children,
  isDisabled,
  isLoading,
  infoPillText,
  isChecked,
  isEditing,
  title,
  shouldEllipse = true,
}) => {
  const fileClasses: string = getClasses(styles.file, {
    [styles.fileChecked]: isChecked,
  });

  const isProcessing: boolean = Boolean(
    isLoading || infoPillText === 'Processing',
  );

  return (
    <Flex className={fileClasses} isYCentered={true} isBetween={true} gap={4}>
      {!isEditing && (
        <>
          {icon && !isDisabled && <Icon name={icon} size={20} />}
          <Text type="small" isEllipsis={shouldEllipse} takeAvailableSpace>
            {title}
          </Text>
          {infoPillText && (
            <Pill label={infoPillText} intent="info" isLoading={isProcessing} />
          )}
        </>
      )}
      {children && (
        <ButtonGroup className={styles.fileButtons} isSmallGroup={true}>
          {children}
        </ButtonGroup>
      )}
    </Flex>
  );
};
